
export function t(key, ...args) {
  let msg = window.app.messages[key]
  if (!msg) {
    return key
  }
  for (let i=0; i<args.length; i++) {
    msg = msg.replace('{'+i+'}', args[i])
  }
  return msg
}